import { motion } from 'framer-motion';
import { FaChevronRight, FaTimes } from 'react-icons/fa';
import { Link, useLocation, matchPath } from "react-router-dom";
import "./SidebarComponent.css";

const SidebarComponent = (props) => {
    let {
        collapsed = false,
        toggleCollapse,
        menuItems,
        mobileOpen = false,
        onMobileClose,
        version,
    } = props;
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <motion.div
            animate={{ width: collapsed ? 70 : 250 }}
            transition={{ duration: 0.3, type: 'tween' }}
            className="sidebar"
        >
            {/* Top section */}
            <div className="top-section">
                <div className="logo">
                    <img src="/Logo/Skillverse-Circle.png" alt="logo" className='logo-circle' />
                    {!collapsed && (
                        <div className="logo-text">
                            <h3>SkillVerse</h3>
                        </div>
                    )}
                </div>
                {/* Mobile close button */}
                <FaTimes
                    className="sidebar-mobile-close"
                    onClick={onMobileClose}
                />
                {/* Desktop collapse toggle */}
                <FaChevronRight
                    className={`toggle-button ${collapsed ? 'rotate' : ''}`}
                    onClick={toggleCollapse}
                />
            </div>

            {/* Menu items */}
            <ul className="menu">
                {menuItems.map((item, index) => {
                    const isActive = item.matchPaths.some(path =>
                        matchPath(
                            { path, end: item.label === 'Dashboard' },
                            currentPath
                        )
                    ) || false;

                    return (
                        <li key={index}>
                            <Link
                                to={item.path}
                                className={`menu-link ${isActive ? 'active' : ''}`}
                                onClick={onMobileClose}
                                title={collapsed ? item.label : undefined}
                            >
                                <span className="menu-icon">{item.icon}</span>
                                {!collapsed && <span className="menu-label">{item.label}</span>}
                            </Link>
                        </li>
                    );
                })}
            </ul>

            {/* Version badge */}
            <div style={{
                marginTop: "auto",
                padding: collapsed ? "12px 0" : "12px 16px",
                borderTop: "1px solid rgba(255,255,255,0.07)",
                textAlign: collapsed ? "center" : "left",
            }}>
                {collapsed ? (
                    <span title={`v${version}`} style={{
                        fontSize: 10, color: "rgba(0,0,0,0.38)",
                        fontFamily: "monospace",
                    }}>v</span>
                ) : (
                    <span style={{
                        fontSize: 11, color: "rgba(0,0,0,0.38)",
                        fontFamily: "ui-monospace, 'SF Mono', Consolas, monospace",
                        letterSpacing: "0.03em",
                    }}>v{version}</span>
                )}
            </div>
        </motion.div>
    );
};
export default SidebarComponent;
